import {
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import Dropdown from "../../reusableComponents/components/generics/Dropdown";

import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchVerifyByInsuree } from "../../action";
import CalendarPicker from "../../pickers/CalenderPicker";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

export const buildQueryParams = (state, searchValue, dropValue) => {
  let params = Object.keys(state.filters)
    .filter((f) => !!state.filters[f]["filter"])
    .map((f) => state.filters[f]["filter"]);
  if (!state.beforeCursor && !state.afterCursor) {
    params.push(`first: ${state.pageSize}`);
  }
  if (!!state.afterCursor) {
    params.push(`after: "${state.afterCursor}"`);
    params.push(`first: ${state.pageSize}`);
  }
  if (searchValue) {
    if (dropValue == 1) {
      params.push(`camuNumber_Icontains: "${searchValue}"`);
    }
    if (dropValue == 2) {
      params.push(`otherNames_Icontains: "${searchValue}"`);
    }
    if (dropValue == 3) {
      params.push(`lastName_Icontains: "${searchValue}"`);
    }
    if (dropValue == 4) {
      params.push(`insuree_Dob: "${searchValue}"`);
    }
    if (dropValue == 5) {
      params.push(`insuree_Phone_Icontains: "${searchValue}"`);
    }
  } else {
    params.push(`healthFacilityId: ${state.healthFacilityId}`);
  }
  if (!!state.beforeCursor) {
    params.push(`before: "${state.beforeCursor}"`);
    params.push(`last: ${state.pageSize}`);
  }
  if (!!state.orderBy) {
    params.push(`orderBy: ["${state.orderBy}"]`);
  }
  if (!!state.policyHolderId) {
    params.push(`policyHolder_Id: "${state.policyHolderId}"`);
  }
  params.push(`ignoreLocation: true`);
  return params;
};

function VerificationFilter() {
  const { t } = useTranslation();

  const SignInSuccess = useSelector((state) => state);

  const [dropValue, setDropValue] = React.useState(0);

  const [showCalendar, setShowCalendar] = React.useState(false);

  const [searchValue, setSearchValue] = useState("");

  const [label, setLabel] = React.useState("Enter CAMU No.");

  const [pageSize, setPageSize] = useState(10);

  const dispatch = useDispatch();

  const [filter, setFilter] = useState(false);

  const policyHolderId = "c47d8640-8b8c-4d96-a220-93928c7e543f";

  const handleChange = (event) => {
    setDropValue(event.target.value);
    getLabel(event);
    if (event.target.value == "4") {
      setShowCalendar(true);
    } else {
      setShowCalendar(false);
    }
  };

  const handleSearch = (event) => {
    let params = buildQueryParams(
      {
        filters: filter,
        orderBy: "chfId",
        pageSize,
        healthFacilityId:
          SignInSuccess?.profileReducer?.currentUserResponseData?.i_user
            ?.health_facility_id,
        // policyHolderId: localStorage.getItem("policyholderId"),
      },
      searchValue,
      dropValue
    );
    dispatch(fetchVerifyByInsuree(params));
  };

  const handleClear = (event) => {
    setSearchValue("");
    // setDropValue(0);
    // let params = buildQueryParams({
    //     filters: filter,
    //     orderBy: "insuree",
    //     pageSize,
    //     policyHolderId: "c47d8640-8b8c-4d96-a220-93928c7e543f",
    //   });
    // dispatch(fetchVerifyByInsuree(params));
  };

  const onsubmit = (event) => {};

  const getLabel = (event) => {
    switch (event.target.value) {
      case 1:
        setLabel("EnterCAMUNo.");
        break;
      case 2:
        setLabel("EnterFirstName");
        break;
      case 3:
        setLabel("EnterLastName");
        break;
      case 4:
        setLabel("EnterDateofBirth");
        break;
      case 5:
        setLabel("EnterPhoneNo");
        break;
      default:
        setLabel("EnterCAMUNo.");
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("camuNo"),
    },
    {
      value: 2,
      label: t("First Name"),
    },
    {
      value: 3,
      label: t("Last Name"),
    },
    {
      value: 4,
      label: t("dob"),
    },
    {
      value: 5,
      label: t("Phone No."),
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("searchInsuree")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {}}
            render={({ handleSubmit, form }) => (
              <form onSubmit={onsubmit}>
                <Grid
                  style={{
                    display: "flex",
                    marginLeft: ".5rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={dropValue}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  {dropValue != 0 && (
                    <Grid item xs={3} className="common-input">
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                      {!showCalendar && (
                        <TextField
                          name="name"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          size="small"
                          type="text"
                          autoComplete="off"
                        />
                      )}

                      {showCalendar && (
                        <Field
                          name="validTo"
                          component={CalendarPicker}
                          onChange={(value) => {
                            setSearchValue(value);
                          }}
                        />
                      )}
                    </Grid>
                  )}
                  {dropValue != 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={!searchValue}
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default VerificationFilter;
